/*
  Note:
  Add future denominations here if needed.
*/

import { DenominationInfo } from '@components/DenominationLadders/DenominationLadderTypes';

import { PouchSubType } from '@api/generator';

import { CURRENCY_ITEM_IDS } from './transactionConstants';

export const CashBalanceDenominations: DenominationInfo[] = [
  {
    itemID: '655',
    label: '£50.00 Notes',
    unitValuePence: 5000,
    denominationAmount: 50,
    currency: 'GBP',
    type: 'note',
    maxQuantityInBag: null,
  },
  {
    itemID: '656',
    label: '£20.00 Notes',
    unitValuePence: 2000,
    denominationAmount: 20,
    currency: 'GBP',
    type: 'note',
    maxQuantityInBag: null,
  },
  {
    itemID: '657',
    label: '£10.00 Notes',
    unitValuePence: 1000,
    denominationAmount: 10,
    currency: 'GBP',
    type: 'note',
    maxQuantityInBag: null,
  },
  {
    itemID: '658',
    label: '£5.00 Notes',
    unitValuePence: 500,
    denominationAmount: 5,
    currency: 'GBP',
    type: 'note',
    maxQuantityInBag: null,
  },
  {
    itemID: '357',
    label: '£2.00 Coins',
    unitValuePence: 200,
    denominationAmount: 2,
    currency: 'GBP',
    type: 'coin',
    maxQuantityInBag: null,
  },
  {
    itemID: '660',
    label: '£1.00 Coins',
    unitValuePence: 100,
    denominationAmount: 1,
    currency: 'GBP',
    type: 'coin',
    maxQuantityInBag: null,
  },
  {
    itemID: '661',
    label: '50p Coins',
    unitValuePence: 50,
    denominationAmount: 50,
    currency: 'p',
    type: 'coin',
    maxQuantityInBag: null,
  },
  {
    itemID: '2191',
    label: '20p Coins',
    unitValuePence: 20,
    currency: 'p',
    denominationAmount: 20,
    type: 'coin',
    maxQuantityInBag: null,
  },
  {
    itemID: '2190',
    label: '10p Coins',
    unitValuePence: 10,
    currency: 'p',
    denominationAmount: 10,
    type: 'coin',
    maxQuantityInBag: null,
  },
  {
    itemID: '2189',
    label: '5p Coins',
    currency: 'p',
    unitValuePence: 5,
    denominationAmount: 5,
    type: 'coin',
    maxQuantityInBag: null,
  },
  {
    itemID: '663',
    label: '2p Coins',
    currency: 'p',
    unitValuePence: 2,
    denominationAmount: 2,
    type: 'coin',
    maxQuantityInBag: null,
  },
  {
    itemID: '662',
    label: '1p Coins',
    currency: 'p',
    denominationAmount: 1,
    unitValuePence: 1,
    type: 'coin',
    maxQuantityInBag: null,
  },
  {
    itemID: '3320',
    label: 'Non-Usable Notes',
    currency: null,
    denominationAmount: null,
    unitValuePence: null, // user specifies only the Value for this field. The Quantity is disabled
    type: 'unusableNote', // Not changing this typing to 'nonUsableNote' until it's certain to do so
    maxQuantityInBag: null,
  },
  {
    itemID: '3321',
    label: 'Non-Usable Coins',
    denominationAmount: null,
    currency: null,
    unitValuePence: null, // user specifies only the Value for this field. The Quantity is disabled
    type: 'unusableCoin', // Not changing this typing to 'nonUsableCoin' until it's certain to do so
    maxQuantityInBag: null,
  },
];

export interface RawDenomination {
  itemID: string;
  denomination: number | null;
  currency: 'GBP' | 'p' | null;
  materialType: 'NOTE' | 'COIN';
  itemType: 'fullBag' | 'partBag' | 'coin' | 'note' | 'unusableCoin' | 'unusableNote';
  maxQuantityInBag: number | null;
}

export const rawDenominations: Record<string, RawDenomination> = {
  // Notes / coins
  [CURRENCY_ITEM_IDS.NOTE_50_POUND_ID]: {
    itemID: CURRENCY_ITEM_IDS.NOTE_50_POUND_ID,
    denomination: 50,
    currency: 'GBP',
    materialType: 'NOTE',
    itemType: 'note',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.NOTE_20_POUND_ID]: {
    itemID: CURRENCY_ITEM_IDS.NOTE_20_POUND_ID,
    denomination: 20,
    currency: 'GBP',
    materialType: 'NOTE',
    itemType: 'note',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.NOTE_10_POUND_ID]: {
    itemID: CURRENCY_ITEM_IDS.NOTE_10_POUND_ID,
    denomination: 10,
    currency: 'GBP',
    materialType: 'NOTE',
    itemType: 'note',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.NOTE_5_POUND_ID]: {
    itemID: CURRENCY_ITEM_IDS.NOTE_5_POUND_ID,
    denomination: 5,
    currency: 'GBP',
    materialType: 'NOTE',
    itemType: 'note',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.COIN_2_POUND_ID]: {
    itemID: CURRENCY_ITEM_IDS.COIN_2_POUND_ID,
    denomination: 2,
    currency: 'GBP',
    materialType: 'COIN',
    itemType: 'coin',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.COIN_1_POUND_ID]: {
    itemID: CURRENCY_ITEM_IDS.COIN_1_POUND_ID,
    denomination: 1,
    currency: 'GBP',
    materialType: 'COIN',
    itemType: 'coin',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.COIN_50_PENCE_ID]: {
    itemID: CURRENCY_ITEM_IDS.COIN_50_PENCE_ID,
    denomination: 50,
    currency: 'p',
    materialType: 'COIN',
    itemType: 'coin',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.COIN_20_PENCE_ID]: {
    itemID: CURRENCY_ITEM_IDS.COIN_20_PENCE_ID,
    denomination: 20,
    currency: 'p',
    materialType: 'COIN',
    itemType: 'coin',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.COIN_10_PENCE_ID]: {
    itemID: CURRENCY_ITEM_IDS.COIN_10_PENCE_ID,
    denomination: 10,
    currency: 'p',
    materialType: 'COIN',
    itemType: 'coin',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.COIN_5_PENCE_ID]: {
    itemID: CURRENCY_ITEM_IDS.COIN_5_PENCE_ID,
    denomination: 5,
    currency: 'p',
    materialType: 'COIN',
    itemType: 'coin',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.COIN_2_PENCE_ID]: {
    itemID: CURRENCY_ITEM_IDS.COIN_2_PENCE_ID,
    denomination: 2,
    currency: 'p',
    materialType: 'COIN',
    itemType: 'coin',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.COIN_1_PENCE_ID]: {
    itemID: CURRENCY_ITEM_IDS.COIN_1_PENCE_ID,
    denomination: 1,
    currency: 'p',
    materialType: 'COIN',
    itemType: 'coin',
    maxQuantityInBag: null,
  }, // Full bags
  [CURRENCY_ITEM_IDS.BAG_2_POUND_FULL_ID]: {
    itemID: CURRENCY_ITEM_IDS.BAG_2_POUND_FULL_ID,
    denomination: 2,
    currency: 'GBP',
    materialType: 'COIN',
    itemType: 'fullBag',
    maxQuantityInBag: 250,
  },
  [CURRENCY_ITEM_IDS.BAG_1_POUND_FULL_ID]: {
    itemID: CURRENCY_ITEM_IDS.BAG_1_POUND_FULL_ID,
    denomination: 1,
    currency: 'GBP',
    materialType: 'COIN',
    itemType: 'fullBag',
    maxQuantityInBag: 500,
  },
  [CURRENCY_ITEM_IDS.BAG_50_PENCE_FULL_ID]: {
    itemID: CURRENCY_ITEM_IDS.BAG_50_PENCE_FULL_ID,
    denomination: 50,
    currency: 'p',
    materialType: 'COIN',
    itemType: 'fullBag',
    maxQuantityInBag: 500,
  },
  [CURRENCY_ITEM_IDS.BAG_20_PENCE_FULL_ID]: {
    itemID: CURRENCY_ITEM_IDS.BAG_20_PENCE_FULL_ID,
    denomination: 20,
    currency: 'p',
    materialType: 'COIN',
    itemType: 'fullBag',
    maxQuantityInBag: 1250,
  },
  [CURRENCY_ITEM_IDS.BAG_10_PENCE_FULL_ID]: {
    itemID: CURRENCY_ITEM_IDS.BAG_10_PENCE_FULL_ID,
    denomination: 10,
    currency: 'p',
    materialType: 'COIN',
    itemType: 'fullBag',
    maxQuantityInBag: 1000,
  },
  [CURRENCY_ITEM_IDS.BAG_5_PENCE_FULL_ID]: {
    itemID: CURRENCY_ITEM_IDS.BAG_5_PENCE_FULL_ID,
    denomination: 5,
    currency: 'p',
    materialType: 'COIN',
    itemType: 'fullBag',
    maxQuantityInBag: 2000,
  },
  [CURRENCY_ITEM_IDS.BAG_2_PENCE_FULL_ID]: {
    itemID: CURRENCY_ITEM_IDS.BAG_2_PENCE_FULL_ID,
    denomination: 2,
    currency: 'p',
    materialType: 'COIN',
    itemType: 'fullBag',
    maxQuantityInBag: 1000,
  },
  [CURRENCY_ITEM_IDS.BAG_1_PENCE_FULL_ID]: {
    itemID: CURRENCY_ITEM_IDS.BAG_1_PENCE_FULL_ID,
    denomination: 1,
    currency: 'p',
    materialType: 'COIN',
    itemType: 'fullBag',
    maxQuantityInBag: 2000,
  }, // Partial bags
  [CURRENCY_ITEM_IDS.BAG_2_POUND_PARTIAL_ID]: {
    itemID: CURRENCY_ITEM_IDS.BAG_2_POUND_PARTIAL_ID,
    denomination: 2,
    currency: 'GBP',
    materialType: 'COIN',
    maxQuantityInBag: 10,
    itemType: 'partBag',
  },
  [CURRENCY_ITEM_IDS.BAG_1_POUND_PARTIAL_ID]: {
    itemID: CURRENCY_ITEM_IDS.BAG_1_POUND_PARTIAL_ID,
    denomination: 1,
    currency: 'GBP',
    materialType: 'COIN',
    maxQuantityInBag: 20,
    itemType: 'partBag',
  },
  [CURRENCY_ITEM_IDS.BAG_50_PENCE_PARTIAL_ID]: {
    itemID: CURRENCY_ITEM_IDS.BAG_50_PENCE_PARTIAL_ID,
    denomination: 50,
    currency: 'p',
    materialType: 'COIN',
    itemType: 'partBag',
    maxQuantityInBag: 20,
  },
  [CURRENCY_ITEM_IDS.BAG_20_PENCE_PARTIAL_ID]: {
    itemID: CURRENCY_ITEM_IDS.BAG_20_PENCE_PARTIAL_ID,
    denomination: 20,
    currency: 'p',
    materialType: 'COIN',
    itemType: 'partBag',
    maxQuantityInBag: 50,
  },
  [CURRENCY_ITEM_IDS.BAG_10_PENCE_PARTIAL_ID]: {
    itemID: CURRENCY_ITEM_IDS.BAG_10_PENCE_PARTIAL_ID,
    denomination: 10,
    currency: 'p',
    materialType: 'COIN',
    itemType: 'partBag',
    maxQuantityInBag: 50,
  },
  [CURRENCY_ITEM_IDS.BAG_5_PENCE_PARTIAL_ID]: {
    itemID: CURRENCY_ITEM_IDS.BAG_5_PENCE_PARTIAL_ID,
    denomination: 5,
    currency: 'p',
    materialType: 'COIN',
    itemType: 'partBag',
    maxQuantityInBag: 100,
  },
  [CURRENCY_ITEM_IDS.BAG_2_PENCE_PARTIAL_ID]: {
    itemID: CURRENCY_ITEM_IDS.BAG_2_PENCE_PARTIAL_ID,
    denomination: 2,
    currency: 'p',
    materialType: 'COIN',
    itemType: 'partBag',
    maxQuantityInBag: 50,
  },
  [CURRENCY_ITEM_IDS.BAG_1_PENCE_PARTIAL_ID]: {
    itemID: CURRENCY_ITEM_IDS.BAG_1_PENCE_PARTIAL_ID,
    denomination: 1,
    currency: 'p',
    materialType: 'COIN',
    itemType: 'partBag',
    maxQuantityInBag: 100,
  }, // Unusable notes / coins
  [CURRENCY_ITEM_IDS.NOTE_UNUSABLE_100_POUND_ID]: {
    itemID: CURRENCY_ITEM_IDS.NOTE_UNUSABLE_100_POUND_ID,
    denomination: 100,
    currency: 'GBP',
    materialType: 'NOTE',
    itemType: 'unusableNote',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.NOTE_UNUSABLE_50_POUND_ID]: {
    itemID: CURRENCY_ITEM_IDS.NOTE_UNUSABLE_50_POUND_ID,
    denomination: 50,
    currency: 'GBP',
    materialType: 'NOTE',
    itemType: 'unusableNote',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.NOTE_UNUSABLE_20_POUND_ID]: {
    itemID: CURRENCY_ITEM_IDS.NOTE_UNUSABLE_20_POUND_ID,
    denomination: 20,
    currency: 'GBP',
    materialType: 'NOTE',
    itemType: 'unusableNote',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.NOTE_UNUSABLE_10_POUND_ID]: {
    itemID: CURRENCY_ITEM_IDS.NOTE_UNUSABLE_10_POUND_ID,
    denomination: 10,
    currency: 'GBP',
    materialType: 'NOTE',
    itemType: 'unusableNote',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.NOTE_UNUSABLE_5_POUND_ID]: {
    itemID: CURRENCY_ITEM_IDS.NOTE_UNUSABLE_5_POUND_ID,
    denomination: 5,
    currency: 'GBP',
    materialType: 'NOTE',
    itemType: 'unusableNote',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.NOTE_UNUSABLE_1_POUND_ID]: {
    itemID: CURRENCY_ITEM_IDS.NOTE_UNUSABLE_1_POUND_ID,
    denomination: 1,
    currency: 'GBP',
    materialType: 'NOTE',
    itemType: 'unusableNote',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.COIN_UNUSABLE_5_POUND_ID]: {
    itemID: CURRENCY_ITEM_IDS.COIN_UNUSABLE_5_POUND_ID,
    denomination: 5,
    currency: 'GBP',
    materialType: 'COIN',
    itemType: 'unusableCoin',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.COIN_UNUSABLE_2_POUND_ID]: {
    itemID: CURRENCY_ITEM_IDS.COIN_UNUSABLE_2_POUND_ID,
    denomination: 2,
    currency: 'GBP',
    materialType: 'COIN',
    itemType: 'unusableCoin',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.COIN_UNUSABLE_1_POUND_ID]: {
    itemID: CURRENCY_ITEM_IDS.COIN_UNUSABLE_1_POUND_ID,
    denomination: 1,
    currency: 'GBP',
    materialType: 'COIN',
    itemType: 'unusableCoin',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.COIN_UNUSABLE_50_PENCE_ID]: {
    itemID: CURRENCY_ITEM_IDS.COIN_UNUSABLE_50_PENCE_ID,
    denomination: 50,
    currency: 'p',
    materialType: 'COIN',
    itemType: 'unusableCoin',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.COIN_UNUSABLE_20_PENCE_ID]: {
    itemID: CURRENCY_ITEM_IDS.COIN_UNUSABLE_20_PENCE_ID,
    denomination: 20,
    currency: 'p',
    materialType: 'COIN',
    itemType: 'unusableCoin',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.COIN_UNUSABLE_10_PENCE_ID]: {
    itemID: CURRENCY_ITEM_IDS.COIN_UNUSABLE_10_PENCE_ID,
    denomination: 10,
    currency: 'p',
    materialType: 'COIN',
    itemType: 'unusableCoin',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.COIN_UNUSABLE_5_PENCE_ID]: {
    itemID: CURRENCY_ITEM_IDS.COIN_UNUSABLE_5_PENCE_ID,
    denomination: 5,
    currency: 'p',
    materialType: 'COIN',
    itemType: 'unusableCoin',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.COIN_UNUSABLE_2_PENCE_ID]: {
    itemID: CURRENCY_ITEM_IDS.COIN_UNUSABLE_2_PENCE_ID,
    denomination: 2,
    currency: 'p',
    materialType: 'COIN',
    itemType: 'unusableCoin',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.COIN_UNUSABLE_1_PENCE_ID]: {
    itemID: CURRENCY_ITEM_IDS.COIN_UNUSABLE_1_PENCE_ID,
    denomination: 1,
    currency: 'p',
    materialType: 'COIN',
    itemType: 'unusableCoin',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.UNUSABLE_NOTES_ID]: {
    itemID: CURRENCY_ITEM_IDS.UNUSABLE_NOTES_ID,
    denomination: null,
    currency: null,
    itemType: 'unusableNote',
    materialType: 'NOTE',
    maxQuantityInBag: null,
  },
  [CURRENCY_ITEM_IDS.UNUSABLE_COINS_ID]: {
    itemID: CURRENCY_ITEM_IDS.UNUSABLE_COINS_ID,
    denomination: null,
    currency: null,
    itemType: 'unusableCoin',
    materialType: 'COIN',
    maxQuantityInBag: null,
  },
};

export type DenominationLadderType = PouchSubType | 'cash_balance';

export const denominationsForDenominationLadderType: Record<DenominationLadderType, string[][]> = {
  useable_notes: [
    [CURRENCY_ITEM_IDS.NOTE_50_POUND_ID],
    [CURRENCY_ITEM_IDS.NOTE_20_POUND_ID],
    [CURRENCY_ITEM_IDS.NOTE_10_POUND_ID],
    [CURRENCY_ITEM_IDS.NOTE_5_POUND_ID],
  ],
  non_useable_notes: [
    [CURRENCY_ITEM_IDS.NOTE_UNUSABLE_100_POUND_ID],
    [CURRENCY_ITEM_IDS.NOTE_UNUSABLE_50_POUND_ID],
    [CURRENCY_ITEM_IDS.NOTE_UNUSABLE_20_POUND_ID],
    [CURRENCY_ITEM_IDS.NOTE_UNUSABLE_10_POUND_ID],
    [CURRENCY_ITEM_IDS.NOTE_UNUSABLE_5_POUND_ID],
    [CURRENCY_ITEM_IDS.NOTE_UNUSABLE_1_POUND_ID],
  ],
  non_useable_coins: [
    [CURRENCY_ITEM_IDS.COIN_UNUSABLE_5_POUND_ID],
    [CURRENCY_ITEM_IDS.COIN_UNUSABLE_2_POUND_ID],
    [CURRENCY_ITEM_IDS.COIN_UNUSABLE_1_POUND_ID],
    [CURRENCY_ITEM_IDS.COIN_UNUSABLE_50_PENCE_ID],
    [CURRENCY_ITEM_IDS.COIN_UNUSABLE_20_PENCE_ID],
    [CURRENCY_ITEM_IDS.COIN_UNUSABLE_10_PENCE_ID],
    [CURRENCY_ITEM_IDS.COIN_UNUSABLE_5_PENCE_ID],
    [CURRENCY_ITEM_IDS.COIN_UNUSABLE_2_PENCE_ID],
    [CURRENCY_ITEM_IDS.COIN_UNUSABLE_1_PENCE_ID],
  ],
  useable_coins_full_bag: [
    [CURRENCY_ITEM_IDS.BAG_2_POUND_FULL_ID],
    [CURRENCY_ITEM_IDS.BAG_1_POUND_FULL_ID],
    [CURRENCY_ITEM_IDS.BAG_50_PENCE_FULL_ID],
    [CURRENCY_ITEM_IDS.BAG_20_PENCE_FULL_ID],
    [CURRENCY_ITEM_IDS.BAG_10_PENCE_FULL_ID],
    [CURRENCY_ITEM_IDS.BAG_5_PENCE_FULL_ID],
    [CURRENCY_ITEM_IDS.BAG_2_PENCE_FULL_ID],
    [CURRENCY_ITEM_IDS.BAG_1_PENCE_FULL_ID],
  ],
  useable_coins_part_bag: [
    [CURRENCY_ITEM_IDS.BAG_2_POUND_PARTIAL_ID, CURRENCY_ITEM_IDS.COIN_2_POUND_ID],
    [CURRENCY_ITEM_IDS.BAG_1_POUND_PARTIAL_ID, CURRENCY_ITEM_IDS.COIN_1_POUND_ID],
    [CURRENCY_ITEM_IDS.BAG_50_PENCE_PARTIAL_ID, CURRENCY_ITEM_IDS.COIN_50_PENCE_ID],
    [CURRENCY_ITEM_IDS.BAG_20_PENCE_PARTIAL_ID, CURRENCY_ITEM_IDS.COIN_20_PENCE_ID],
    [CURRENCY_ITEM_IDS.BAG_10_PENCE_PARTIAL_ID, CURRENCY_ITEM_IDS.COIN_10_PENCE_ID],
    [CURRENCY_ITEM_IDS.BAG_5_PENCE_PARTIAL_ID, CURRENCY_ITEM_IDS.COIN_5_PENCE_ID],
    [CURRENCY_ITEM_IDS.BAG_2_PENCE_PARTIAL_ID, CURRENCY_ITEM_IDS.COIN_2_PENCE_ID],
    [CURRENCY_ITEM_IDS.BAG_1_PENCE_PARTIAL_ID, CURRENCY_ITEM_IDS.COIN_1_PENCE_ID],
  ],
  cash_balance: [
    [CURRENCY_ITEM_IDS.NOTE_50_POUND_ID],
    [CURRENCY_ITEM_IDS.NOTE_20_POUND_ID],
    [CURRENCY_ITEM_IDS.NOTE_10_POUND_ID],
    [CURRENCY_ITEM_IDS.NOTE_5_POUND_ID],
    [CURRENCY_ITEM_IDS.COIN_2_POUND_ID],
    [CURRENCY_ITEM_IDS.COIN_1_POUND_ID],
    [CURRENCY_ITEM_IDS.COIN_50_PENCE_ID],
    [CURRENCY_ITEM_IDS.COIN_20_PENCE_ID],
    [CURRENCY_ITEM_IDS.COIN_10_PENCE_ID],
    [CURRENCY_ITEM_IDS.COIN_5_PENCE_ID],
    [CURRENCY_ITEM_IDS.COIN_2_PENCE_ID],
    [CURRENCY_ITEM_IDS.COIN_1_PENCE_ID],
    [CURRENCY_ITEM_IDS.UNUSABLE_NOTES_ID],
    [CURRENCY_ITEM_IDS.UNUSABLE_COINS_ID],
  ],
};
